import React from 'react'

export default function Footer() {
  return (
    <footer className='footer'>
      <h3>¡Seguimos evolucionando y mejorando nuestra tecnología!</h3>
    </footer>
  )
}
